import { useEffect, useState } from 'react';

import { ShareParams } from '../types';

type acceptedParameterKeys = 'text' | 'url';

type ShareInformation = {
  text: string;
  url: string;
};

const DEFAULT_TRANSFORMERS: ShareParams = { url: 'url', text: 'text' };

const getShareInformation = (params?: ShareParams): ShareInformation => {
  return {
    text: params?.text ?? document.title,
    url: params?.url ?? window.location.href,
  };
};

export const useNetworkShareUrl = (
  shareUrl: string,
  transformers: ShareParams = DEFAULT_TRANSFORMERS,
  parameters?: ShareParams,
): string => {
  const [shareParameters, setShareParameters] = useState({});

  useEffect(() => {
    setShareParameters(getShareInformation(parameters));
  }, [parameters]);

  const params = Object.entries(shareParameters)
    .filter(([key, value]) => value !== undefined && value !== null && key in transformers)
    .map(([key, value]) => `${transformers[key as acceptedParameterKeys]}=${encodeURIComponent(String(value))}`);

  const queryString = params.length > 0 ? `?${params.join('&')}` : '';

  return `${shareUrl}${queryString}`;
};
